// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unit-code[data-v-05e17b71] {\n  font-weight: 700;\n  color: #007bff;\n}\n", ""]);
// Exports
module.exports = exports;
